import { render, staticRenderFns } from "./QueueNotification.vue?vue&type=template&id=55d2d414"
import script from "./QueueNotification.vue?vue&type=script&lang=js"
export * from "./QueueNotification.vue?vue&type=script&lang=js"
import style0 from "./QueueNotification.vue?vue&type=style&index=0&id=55d2d414&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports